import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { LoaderModule } from '@shopping-angular-components/loader';
import { VideoMiniaturesComponent } from './video-miniatures/video-miniatures.component';
import { TextModule } from '../text/text.module';
import { MiniaturesComponent } from "./miniature/miniature.component";
import { PictureModule } from "../picture/picture.module";
import { MediaPictureService } from "../../services/media-picture.service";
import { SliderModule } from '@shopping-angular-components/slider';
import { EvaButtonModule } from "../eva-button/eva-button.module";
import { TranslateModule } from '@ngx-translate/core';
import { SliderProModule } from '../slider-pro/slider-pro.module';



@NgModule({
  declarations: [
    VideoPlayerComponent,
    VideoMiniaturesComponent,
    MiniaturesComponent
  ],
  imports: [
    CommonModule,
    LoaderModule,
    TextModule,
    PictureModule,
    EvaButtonModule,
    TranslateModule,
    SliderProModule
  ],
  exports: [
    VideoMiniaturesComponent,
    VideoPlayerComponent
  ],
  providers: [
    MediaPictureService
  ]
})
export class VideoPlayerModule { }
